import React from 'react'

export default function UplyftInfo() {
    return (
        <div className="form__infos js-is-seen is-seen" >
            <div className="form__info is-done" data-anime="{&quot;from&quot;:{&quot;opacity&quot;:0,&quot;translateY&quot;:&quot;70px&quot;},&quot;to&quot;:{&quot;opacity&quot;:1,&quot;translateY&quot;:0,&quot;delay&quot;:0,&quot;duration&quot;:1500,&quot;easing&quot;:&quot;easeOutQuart&quot;}}" style={{ opacity: "1", transform: "translateY(0px)" }}>
          
                <div className="form__info__content">Phone: <a  href="tel:800-515-7531">800-515-7531</a><br />Fax: 305-999-5312
                </div>
            </div>
            <div className="form__info is-done" data-anime="{&quot;from&quot;:{&quot;opacity&quot;:0,&quot;translateY&quot;:&quot;70px&quot;},&quot;to&quot;:{&quot;opacity&quot;:1,&quot;translateY&quot;:0,&quot;delay&quot;:400,&quot;duration&quot;:1500,&quot;easing&quot;:&quot;easeOutQuart&quot;}}" style={{ opacity: "1", transform: "translateY(0px)" }}>
            
                <div className="form__info__content">20200 West Dixie Highway<br />Unit. 802 Miami, FL 33180
                </div>
            </div>
            <div className="form__info is-done" data-anime="{&quot;from&quot;:{&quot;opacity&quot;:0,&quot;translateY&quot;:&quot;70px&quot;},&quot;to&quot;:{&quot;opacity&quot;:1,&quot;translateY&quot;:0,&quot;delay&quot;:800,&quot;duration&quot;:1500,&quot;easing&quot;:&quot;easeOutQuart&quot;}}" style={{ opacity: "1", transform: "translateY(0px)" }}>
              
                <div className="form__info__content">
                   
                        <a  href="mailto:sales@uplyftcapital.com">sales@uplyftcapital.com</a>
                   <br />
                       <a  href="mailto:support@uplyftcapital.com">support@uplyftcapital.com</a>
                    
                </div>
            </div>
        </div>
    )
}
